import { useQuery } from '@tanstack/react-query';

import type { OnboardingRecord } from '../types';

import { apiClient } from '@config/server/apiClient';
import { productOnboardingEndpoints } from '@config/server/apiEndpoints';

import { productOnboarding } from './queryKeys';

export const useGetOnboardingRecord = (id: string | null) =>
	useQuery({
		...productOnboarding.record(id ?? ''),
		queryFn: async () => {
			const res = await apiClient.get<OnboardingRecord>(
				productOnboardingEndpoints.record(id!),
			);
			return res.data as OnboardingRecord;
		},
		enabled: !!id,
		staleTime: 10 * 1000,
	});
